import { render } from "./LandingPortalCards.vue?vue&type=template&id=3f6f521e&scoped=true"
import script from "./LandingPortalCards.vue?vue&type=script&lang=js"
export * from "./LandingPortalCards.vue?vue&type=script&lang=js"

import "./LandingPortalCards.vue?vue&type=style&index=0&id=3f6f521e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/checkmarq-backend/checkmarq-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6f521e"]])

export default __exports__